module.exports = __webpack_public_path__ + "img/apiwise3.3373452d.png";